import { RouteConfig } from 'react-router-config'
import Blank from '@/layouts/Blank'
import { withAsync } from '@/components/Async'

const routes: RouteConfig[] = [
  {
    path: '/billManagement',
    component: Blank,
    menuTitle: 'codBill.billManagement',
    permissionCode: 'bills',
    routes: [
      {
        name: 'codBill',
        path: '/codBill',
        permissionCode: 'bills:codBill',
        component: withAsync(() => import(/* webpackChunkName: "addressBook" */ '@/containers/CodBill/List')),
        exact: true,
        main: true,
      },
      {
        name: 'detail',
        path: '/detail/:billCodOrderNo',
        component: withAsync(() => import(/* webpackChunkName: "logisticsDetail" */ '@/containers/CodBill/Detail')),
        exact: true,
      },
      {
        name: 'FreightBillList',
        path: '/freightBillList',
        permissionCode: 'bills:freightBill',
        component: withAsync(() => import(/* webpackChunkName: "addressBook" */ '@/containers/FreightBill/List')),
        exact: true,
        main: true,
      },
      {
        name: 'FreightBillListDetail',
        path: '/freightBillDetail/:id',
        component: withAsync(() => import(/* webpackChunkName: "addressBook" */ '@/containers/FreightBill/Detail')),
        exact: true,
      },
    ],
  },
]

export default routes
